import React from 'react';
import PropTypes from 'prop-types';

import './company.scss';

import CompanyFormContainer from '../../containers/CompanyFormContainer';
import FormTitleComponent from '../../components/core/FormTitleComponent/FormTitleComponent';
import LoadingComponent from '../../components/core/LoadingComponent/LoadingComponent';

class CompanyLayout extends React.Component {
    render() {
        const { isLoading, onSubmit, onClose } = this.props;

        return <div className="new-company">
            {isLoading && <LoadingComponent fullScreen />}
            <h3>Add Company to Account</h3>
            <FormTitleComponent title="Company Information" />
            <CompanyFormContainer
                onSubmit={onSubmit}
                onClose={onClose}
            />
        </div>;
    }
}

CompanyLayout.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default CompanyLayout;



// WEBPACK FOOTER //
// ./src/layouts/Company/CompanyLayout.js